import { Client } from "@smash-sdk/core";
import { HttpRequest, SDKError, config } from "@smash-sdk/core";
import { errors } from "./errors";
export * from "./errors";
export * from "./types/VerifyChallenge/VerifyChallenge";
const endpoints = {
    "ca-central-1": "https://captcha.ca-central-1.fromsmash.co",
    "eu-central-1": "https://captcha.eu-central-1.fromsmash.co",
    "eu-west-1": "https://captcha.eu-west-1.fromsmash.co",
    "eu-west-2": "https://captcha.eu-west-2.fromsmash.co",
    "eu-west-3": "https://captcha.eu-west-3.fromsmash.co",
    "us-east-1": "https://captcha.us-east-1.fromsmash.co",
    "us-east-2": "https://captcha.us-east-2.fromsmash.co",
    "us-west-1": "https://captcha.us-west-1.fromsmash.co",
    "us-west-2": "https://captcha.us-west-2.fromsmash.co",
};
config.setHosts("captcha", endpoints, false);
export class Captcha extends Client {
    constructor(params = {}) {
        super({ service: "captcha", ...params, type: "regional", userAgent: "@smash-sdk/captcha@0.0.0" });
        this.errors = errors;
    }
    verifyChallenge(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/challenge/verify",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2025",
                    },
                    bodyParameters: {
                        token: params["token"],
                        action: params["action"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.VerifyChallengeError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
}
Captcha.errors = errors;
